import {
  CONFIG_GET_RESPONSE,
  CONFIG_ERROR,
  CONFIG_REQUEST,
  CONFIG_UPDATE_DATA,
} from "actions/const";
import {
  STATE_CONFIG_DEFAULT,
  STATE_CONFIG_DATA,
  STATE_CONFIG_ERRORS,
  STATE_CONFIG_FETCHING,
} from "./default";
import { createReducer } from "../base";
import { updateOnlyUpdatedProps } from "./utils";

export default createReducer(STATE_CONFIG_DEFAULT, {
  [CONFIG_GET_RESPONSE]: (state, { data }) =>
    STATE_CONFIG_DEFAULT.set(STATE_CONFIG_DATA, data),
  [CONFIG_REQUEST]: state => state.set(STATE_CONFIG_FETCHING, true),
  [CONFIG_ERROR]: (state, { data }) =>
    STATE_CONFIG_DEFAULT.set(STATE_CONFIG_ERRORS, data),
  [CONFIG_UPDATE_DATA]: (state, { payload: { path, value } }) =>
    state.updateIn([STATE_CONFIG_DATA, ...path], element =>
      updateOnlyUpdatedProps(element, value)
    ),
});

export * from "./selectors";
export * from "./default";
